import React from 'react';

interface SecureImageProps {
  src: string;
  alt: string;
  className?: string;
  onLoad?: () => void;
  onError?: () => void;
  fallbackSrc?: string;
  style?: React.CSSProperties;
}

export const SecureImage: React.FC<SecureImageProps> = ({
  src,
  alt,
  className,
  onLoad,
  onError,
  fallbackSrc,
  style
}) => {
  const handleError = () => {
    if (fallbackSrc && src !== fallbackSrc) {
      // Try fallback if provided and different from current src
      const img = document.createElement('img');
      img.src = fallbackSrc;
      img.onload = () => onLoad?.();
      img.onerror = () => onError?.();
    } else {
      onError?.();
    }
  };

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onLoad={onLoad}
      onError={handleError}
    />
  );
};

export default SecureImage;